import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';

import { HeaderBannerDto } from '../../models/header-banner-dto';

export class HeaderBannerListApi {
    constructor(protected baseUrl: string) {}

    public getHeaderBanners(searchParams: URLSearchParams): Promise<ApiResult<PaginatedResponse<HeaderBannerDto>>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/header-banners`, { params: searchParams }),
            response => response.data
        );
    }
}
